export function applicationSend(companySlug: string, jobOfferSlug: string) {
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "application_send",
    company_slug: companySlug,
    job_offer_slug: jobOfferSlug,
  });
}

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}
